import { NgModule } from '@angular/core';

import { FilterChipsPipe } from './filter-chips.pipe';

@NgModule({
  declarations: [
    FilterChipsPipe,
  ],
  exports: [
    FilterChipsPipe,
  ],
})
export class FilterChipsModule {
}
